import { useUserContext } from "@/contexts/UserContextProvider";
import { Navigate, Outlet } from "react-router-dom";
import PageLoading from "../customComponents/PageLoading";

const PublicRoutes = () => {
  const { user, loading } = useUserContext();

  return loading ? (
    <PageLoading />
  ) : !user ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace />
  );
};

export default PublicRoutes;
